import React from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import illustration from '../../Assests/Adminillustration.png';

const Admin = () => {
    const [admin, setAdmin] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleAdminChange = (e) => {
        setAdmin(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await fetch('https://sirichandhanak-backend.vercel.app/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ admin, password })
            });
            const data = await response.json();

            if (response.ok) {
                console.log(data.message);
                window.localStorage.setItem('authenticated', true);
                window.location.href = './adminpage'
            } else {
                alert('Authentication failed. Please check your credentials.');
            }
        } catch (error) {
            console.error('Error logging in:', error);
            alert('Error logging in. Please try again.');
        }
    };



    return (
        <div className='bg-[#242424] h-screen text-white'>
            <div className=''>
                <div className=' flex '>
                    <div className='w-full mt-32 ml-20'>
                        <img src={illustration} alt='illustration' />
                    </div>
                    <form onSubmit={handleSubmit} className='pt-20 pb-20 mx-40 w-full'>
                        <div>
                            <div className='border-2 border-[#E4B379] shadow-xl shadow-[#E4B379] px-10 py-10'>
                                <div>
                                    <h1 className='m-20 text-4xl flex justify-center'>Admin Login</h1>
                                </div>
                                <div>
                                    <div className='flex justify-center'>
                                        <input
                                            type='text'
                                            value={admin}
                                            onChange={handleAdminChange}
                                            placeholder='username'
                                            className='border-2 rounded-xl w-96 px-10 py-4 text-xl text-black '
                                        />
                                    </div>
                                    <div className='mt-10 flex justify-center'>
                                        <input
                                            type='password'
                                            value={password}
                                            onChange={handlePasswordChange}
                                            placeholder='password'
                                            className='border-2 rounded-xl w-96 px-10 py-4 text-xl text-black'
                                        />
                                    </div>
                                    <div className='ml-14'>
                                        <button type="submit" className="mt-10 px-8 py-1 border-[#E4B379] border bg-[#242424] shadow-md shadow-[#E4B379] text-white rounded-full hover:bg-[#E4B379] hover:text-black hover:shadow-transparent transition-colors">
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Admin;
